import { routerHelpers } from '@approvalmax/utils';
import { useQueryClient } from '@tanstack/react-query';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import { budgetsApiPaths } from 'shared/data/webApp/v1';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { useBudgets } from './useBudgets';

export const useBudgetPolling = () => {
    const { data: budgets } = useBudgets();
    const company = useCompanyBasedOnUrl();
    const queryClient = useQueryClient();

    const somethingIsSyncing = budgets.some((b) => b.syncStatus === domain.BudgetSyncStatus.Synchronizing);

    useEffect(() => {
        let timerHandler: NodeJS.Timeout | undefined;

        const pushPollingQuery = () => {
            timerHandler = setTimeout(async () => {
                timerHandler = undefined;

                const selectBudgetApiurl = routerHelpers.pathToUrl(budgetsApiPaths.xeroBudgets, {
                    integrationType: company.integration?.integrationType,
                });

                queryClient.cancelQueries([selectBudgetApiurl, { companyId: company.id }]);
                queryClient.invalidateQueries([selectBudgetApiurl, { companyId: company.id }]);

                if (somethingIsSyncing) {
                    pushPollingQuery();
                }
            }, 5000);
        };

        if (somethingIsSyncing) {
            pushPollingQuery();
        }

        return () => {
            if (timerHandler) {
                clearTimeout(timerHandler);
            }
        };
    }, [company.id, company.integration?.integrationType, queryClient, somethingIsSyncing]);
};
